import React from 'react';
import { Selector } from 'gwx-ui';
import debounce from 'lodash.debounce';
import { get } from 'gwx-fetch';

/**
 * Provides a Selector component that asynchronously fetches
 * and displays Millennium Realms.
 */
const MillenniumRealmSelector = (props) => {
	const formatResponse = (realms) => realms.map((c) => ({
		label: c.displayName,
		value: c.realmId
	}));

	const getOptions = debounce((input) => get(`/api/millenniumRealms?name=${input}`)
		.then((realms) => (formatResponse(realms))), 300, { leading: true });

	return <Selector {...props} loadOptions={getOptions} />;
};

export default MillenniumRealmSelector;